export default __webpack_public_path__ + "static/media/dashboard-reports-transparent.df0ea3cb.svg";